module.exports = {
      id: "back-to-top-button-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#back-to-top-button",
      toString: function () {
        return this.url;
      }
    }